import "./advertisement.scss";
import AdvertisementForm from "./advertisementForm";
import AdvertisementPreview from "./advertisementPreview";
import React, { useState } from "react";
import logo from "../../../assets/images/logo.png";

function Advertisement(props) {
  let today = new Date();
  let tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const [horizontalValue, setHorizontalValue] = useState(1);
  const [verticalValue, setVerticalValue] = useState(1);
  const [form_to_file, changeFormToFile] = useState(true);
  const [image, setimage] = useState(logo);
  const [originalFile, setOriginalFile] = useState(null);
  const [date, setDate] = useState(tomorrow);
  const [number, setNumber] = useState(props.number);
  const [paperType, setPaperType] = useState("");
  const [sectorType, setSectorType] = useState("");

  const handleChangeHorizontal = (event) => {
    setHorizontalValue(() => {
      return event.target.value;
    });
  };

  const handleChangeVertical = (event) => {
    setVerticalValue(() => {
      return event.target.value;
    });
  };

  const handleFormToFile = () => {
    if (sectorType === null || sectorType === "") {
      return toastr.info("Please Select Sector");
    } else if (paperType === null || paperType === "") {
      return toastr.info("Please Select Paper");
    } else if (date === "") {
      return toastr.info("Please Select Publish Date");
    } else if (number.length === 0) {
      return toastr.info("Please Enter Number");
    } else if (number.length !== 10 || number.match(/^[0-9]+$/) === null) {
      return toastr.info("Please Enter Valid Number");
    } else if (originalFile == null) {
      return toastr.info("Please Upload Image");
    }
    changeFormToFile((prev) => {
      return !prev;
    });
  };

  const handleChangeImg = (image) => {
    setimage(() => {
      return image;
    });
  };

  return (
    <>
      <div className="advertisement">
        <div className="container">
          <div>
            {form_to_file ? (
              <div className="section-card 1">
                <AdvertisementForm
                  verticalValue={verticalValue}
                  horizontalValue={horizontalValue}
                  handleChangeHorizontal={handleChangeHorizontal}
                  handleChangeVertical={handleChangeVertical}
                  handleChangeImg={handleChangeImg}
                  image={image}
                  handleFormToFile={handleFormToFile}
                  setOriginalFile={setOriginalFile}
                  date={date}
                  setDate={setDate}
                  number={number}
                  setNumber={setNumber}
                  sector={props.sector}
                  paper={props.paper}
                  paperType={paperType}
                  sectorType={sectorType}
                  setSectorType={setSectorType}
                  setPaperType={setPaperType}
                />
              </div>
            ) : (
              <div className="section-card platform-section-card">
                <AdvertisementPreview
                  verticalValue={verticalValue}
                  horizontalValue={horizontalValue}
                  image={image}
                  handleFormToFile={handleFormToFile}
                  categoryID={props.category_id}
                  originalFile={originalFile}
                  date={date}
                  number={number}
                  paperType={paperType}
                  sectorType={sectorType}
                  sector={props.sector}
                  paper={props.paper}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Advertisement;
